<template>
    <main id="data-sets">
        <confirm id="confirmDeleteDataSet" ref="confirmDeleteDataSet" @confirm="deleteDataSet(dataSetToShowInModal.id)">
            <template slot="title">
                <span>
                    {{ t('dataSets-list-confirm_delete_title') }}
                    <b>"{{ dataSetToShowInModal.name }}"</b>?
                </span>
            </template>
            <template slot="body">
                {{ t('dataSets-list-confirm_delete_body') }}
            </template>
        </confirm>
        <loader v-if="loading"></loader>
        <span v-if="dataSets.length === 0 && search.trim() === '' && !loading" class="alert alert-info mb-4 mx-3">
            {{ t('dataSets-list-empty_alert') }}
            <strong> {{ t('dataSets-list-create_first') }} </strong>
        </span>
        <div class="coluna col-md-6">
            <div v-if="dataSets.length !== 0" class="input-group mb-3">
                <input id="dataSetsSearch" name="search" v-model="search" :placeholder="t('dataSets-list-filter_placeholder')"
                    :aria-label="t('dataSets-list-filter_placeholder')" type="text" class="form-control"
                    aria-describedby="cleansearch" />
                <div class="input-group-append">
                    <button @click="search = ''" class="btn btn-outline-secondary" type="button" id="cleansearch">
                        <i class="fa fa-eraser"></i>
                    </button>
                </div>
            </div>
            <router-link to="data-sets/new" class="btn btn-primary mt-4 mb-4">
                {{ t('dataSets-list-create_new') }}
            </router-link>
            <ul class="dataSets-list" v-if="filteredDataSets.length">
                <li v-for="dataSet in filteredDataSets" :key="dataSet.id" class="box">
                    <article id="dataSet-info">
                        <div class="dataSet-info">
                            <h2>{{ dataSet.name }}</h2>
                            <span>
                                {{ dataSet.description }}
                            </span>
                        </div>
                        <div class="dataSet-actions">
                            <router-link :to="'/data-sets/edit/' + dataSet.id" :aria-label="t('dataSets-list-edit_tooltip')">
                                <Icon icon-class="ui-edit-05" :tooltip="t('dataSets-list-edit_tooltip')" />
                            </router-link>
                            <button @click="openConfirmDeleteDataSet(dataSet)" :aria-label="t('dataSets-list-delete_tooltip')">
                                <Icon icon-class="ui-trash-01" :tooltip="t('dataSets-list-delete_tooltip')" />
                            </button>
                        </div>
                    </article>
                </li>
            </ul>
        </div>
        <span v-if="filteredDataSets.length === 0 && search.trim() !== ''" class="alert alert-info">
            {{ t('dataSets-list-no_results') }}
            <strong> {{ search }} </strong>
        </span>
    </main>
</template>

<style scoped lang="less">
@media (max-width: 1000px) and (min-width: 768px) {
    main#data-sets {
        .coluna {
            max-width: 100%;
        }
    }
}

@media (max-width: 1320px) and (min-width:1000px) {
    main#data-sets {
        .coluna {
            max-width: 70%;
        }
    }
}

main#data-sets {
    ul.dataSets-list {
        width: 100%;
        margin-top: 20px;
        list-style: none;
        padding: 0;

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            article#dataSet-info {
                flex-grow: 1;
                margin-left: 10px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-end;

                div {
                    display: flex;
                    justify-content: center;
                    gap: 4px;

                    a,
                    button {
                        width: fit-content;
                        height: fit-content;
                    }
                }

                div.dataSet-info {
                    flex-direction: column;
                    margin-right: 4px;

                    span {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-all;
                    }
                }
                div.dataSet-actions {
                    a,
                    button {
                        background: transparent;
                        border: none;
                        color: #1F2A37;
                    }

                    button {
                        color: var(--danger);
                    }
                }

                h2 {
                    margin: 0;
                    font-size: 1rem;
                }

                span {
                    font-size: 0.8rem;
                    color: #666;
                }
            }

        }
    }
}
</style>

<script>
import keviApi from "../keviApi";
import Icon from "../components/icon/icon";

export default {
    name: "data-sets",
    components: {
        Icon
    },
    data() {
        return {
            dataSets: [],
            search: "",
            dataSetToShowInModal: {
                id: null,
                name: null,
            },
            error: null,
            loading: true
        };
    },
    computed: {
        filteredDataSets() {
            return this.search.trim() === "" ? this.dataSets :
                this.dataSets.filter(dataSet => dataSet.name.toLowerCase().includes(this.search.toLowerCase()));
        }
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            "Kevi | " + this.t('dataSets-title');
    },
    mounted() {
        const options = keviApi.getOptions("data-sets");
        this.$http(options).then(response => {
            this.dataSets = Object.values(response.data.dataSets);
        }).catch(_error => {
            this.error = this.t('dataSets-list-error_loading');
        }).then(() => {
            this.loading = false;
        });
    },
    methods: {
        openConfirmDeleteDataSet(dataSet) {
            this.dataSetToShowInModal = dataSet;
            this.$refs["confirmDeleteDataSet"].open();
        },
        deleteDataSet(id) {
            const options = keviApi.getOptions("data-sets/" + id, "DELETE");
            this.$http(options).then(() => {
                this.dataSets = this.dataSets.filter(dataSet => dataSet.id !== id);
                this.$store.dispatch(
                    "notification/success",
                    this.t('dataSets-list-delete_success'),
                );
            }).catch(_error => {
                this.error = this.t('dataSets-list-error_deleting');
            });
        },
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
